<template>
    <b-modal
        v-model="modal"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :title="$t('assignment.page.edit')"
        :ok-title="$t('common.save')"
        modal-class="apprentice-default-modal">
        <div class="update-sub-assignment-page-title">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                label="Naam"
                label-for="sub-assignment-page-title-input">
                <b-form-input
                    id="sub-assignment-page-title-input"
                    v-model="name"
                    :placeholder="$t('assignment.page.title')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-assignment-edit-page-modal',
    props: ['pageIn'],
    data() {
        return {
            name: '',
            modal: false,
            id: 0,
            hasError: false,
            errorMessage: '',
        };
    },
    methods: {
        show(page) {
            this.modal = true;
            this.name = page.name;
            this.id = page.id;
            this.hasError = false;
        },

        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();

            const data = {
                name: this.name,
            };

            this.axios.post(this.routes.assignmentPageUpdate(this.id), data).then(
                (response) => {
                    this.$emit('sub-assignment-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        checkForErrors() {
            this.hasError = false;

            if (this.name && this.name.length > 192) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.page.title_max_length');
            }
        },
    },
};
</script>

<style scoped></style>
